import { render, staticRenderFns } from "./SelectProposalStatuses.vue?vue&type=template&id=63324543"
import script from "./SelectProposalStatuses.vue?vue&type=script&lang=js"
export * from "./SelectProposalStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports